var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-492"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-492",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-492"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.88,210s-9.1,3.3-7.51,7.91,12.46-1.62,12.46-1.62Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88,210s-9.1,3.3-7.51,7.91,12.46-1.62,12.46-1.62Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,199.84c-5.05,1.07-17.9,9.82-17.9,9.82l4.35,10.43,11.64-3.84Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.32 401.76 146.02 405.38 138.46 391.68 144.76 388.05 152.32 401.76",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,404.57l7-4.45a.58.58,0,0,1,.75.06l4.23,4.39a1.06,1.06,0,0,1-.12,1.49l-.18.12c-2.44,1.49-3.77,2.17-6.81,4.11-1.87,1.18-9.81,5.45-12.74,5.66s-3.26-2.57-2.07-3c6-2.24,8.37-5.11,9.14-7.37A2,2,0,0,1,145.25,404.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.76 388.05 138.46 391.68 142.36 398.74 148.66 395.12 144.76 388.05",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,241s-20.62,68.37-19.49,88.69c1.24,22.28,31.19,69.15,31.19,69.15l11.29-7.13S129,345.48,128.21,328.38c1.17-24.74,26.89-84.83,26.89-84.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.54,265c-6.24,3.82-8.71,20.09-7.39,28.35,3.37-10.46,7.22-20.77,10.3-28.68A2.93,2.93,0,0,0,143.54,265Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.62 399.88 150.93 391.44 148.75 387.69 134.79 396.2 137.62 399.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81,406.88a2.4,2.4,0,0,1-1.37.46.91.91,0,0,1-.72-.54.57.57,0,0,1,0-.54c.5-.77,3.16-.89,3.46-.89a.13.13,0,0,1,.14.09.15.15,0,0,1,0,.18A9.65,9.65,0,0,1,143.81,406.88Zm-1.62-.62a.44.44,0,0,0-.17.16.17.17,0,0,0,0,.21.56.56,0,0,0,.49.38,3.77,3.77,0,0,0,2.24-1.29A7.24,7.24,0,0,0,142.19,406.26Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.27,405.68h-.08c-.83.08-2.81-.42-3.06-1.15a.57.57,0,0,1,.26-.65.94.94,0,0,1,.72-.22c1,.09,2.17,1.68,2.21,1.78a.14.14,0,0,1,0,.17Zm-2.62-1.57-.06,0c-.18.15-.15.24-.14.28.15.43,1.5.89,2.39.95-.35-.45-1.12-1.31-1.78-1.37a.66.66,0,0,0-.41.1Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.05 410 159.05 410 158.47 393.77 165.48 393.77 166.05 410",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,409.19h8.51a.61.61,0,0,1,.59.48l1.39,6.24a1,1,0,0,1-.8,1.22.91.91,0,0,1-.23,0c-2.75-.05-4.76-.22-8.22-.22-2.13,0-8.55.23-11.49.23s-3.33-2.91-2.12-3.18c5.4-1.17,9.46-2.8,11.19-4.36A1.7,1.7,0,0,1,158.08,409.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.48 393.78 158.47 393.78 158.77 402.15 165.78 402.15 165.48 393.78",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,242.34s5.71,67,8.66,87.3c3.24,22.28,10.16,70.89,10.16,70.89h12.82s-2.62-46.53-3.83-68.42c-1.39-25-2.06-87.66-2.06-87.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.01 400.8 169.13 400.8 169.13 396.28 153.44 395.99 154.01 400.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.76,410.42a2.09,2.09,0,0,1-1.35-.36,1,1,0,0,1-.34-.89.47.47,0,0,1,.28-.46c.78-.4,3,1,3.29,1.15a.15.15,0,0,1,.08.16.17.17,0,0,1-.12.14A8.87,8.87,0,0,1,155.76,410.42Zm-1-1.45a.41.41,0,0,0-.22,0s-.1.06-.1.2a.66.66,0,0,0,.22.59,3.35,3.35,0,0,0,2.49.13A6.71,6.71,0,0,0,154.72,409Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,410.17h-.08c-.72-.39-2.12-1.93-2-2.67a.55.55,0,0,1,.54-.44.89.89,0,0,1,.7.21c.81.66,1,2.68,1,2.77a.19.19,0,0,1-.08.16Zm-1.41-2.84h-.08c-.21,0-.23.12-.24.17-.09.45.8,1.62,1.53,2.16a4,4,0,0,0-.83-2.19A.59.59,0,0,0,156.14,407.33Z",
    style: {
      fill: "#4B706C"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "131.38 253.01 149.33 253.23 149.33 248.85 131.38 248.85 131.38 253.01"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.69 248.85 150.69 253.24 162.96 253.39 162.96 248.85 150.69 248.85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "130.02 248.85 124.8 248.85 124.31 252.92 130.02 252.99 130.02 248.85"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.13,
    y: 248.05,
    width: 7.06,
    height: 5.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.11,248.23l38.18,2.53c2.09-18.51,8.18-37.55,10-44.28a1.83,1.83,0,0,0-1.26-2.25c-1.89-.55-3.85-1-5.82-1.48a185.81,185.81,0,0,0-27.09-3.63,16.41,16.41,0,0,0-6.5.71C126.88,216.07,125.53,235.92,125.11,248.23Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,219.13c-.36,1.38-.75,2.83-1.13,4.33a204.31,204.31,0,0,0-5.3,27.3l-38.18-2.53a210.1,210.1,0,0,1,3.67-34.3,0,0,0,0,1,0,0c3.82-8.76,13.4-12.56,13.4-12.56s1.06,2.26,5.81,2.92,11.09-.82,11.09-.82c7.39,5.84,9.28,16.57,9.28,16.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,211.85c-.91,3.18-2,7.14-3.17,11.61-4.18-5.88-.45-14.42-.45-14.42A8.24,8.24,0,0,1,171.76,211.85Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.34,201.58c-3.28,3-11.31,1.87-11.31,1.87s-5-1.37-4-2.94c3-.48,4.39-1.86,5-3.63a8.68,8.68,0,0,0,.3-3.37c0-.28-.05-.56-.09-.83s-.1-.7-.16-1.05l9.93-7.36c-.36,1.34-.74,3-1,4.77-.7,4.17-.92,9,.76,11.72A4.94,4.94,0,0,0,159.34,201.58Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.68,197.63c-3.62-.4-6.32-2.74-8.59-6l8.39.7A32.27,32.27,0,0,0,157.68,197.63Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.31,216.16c-.83,5.13,2.23,6.63,14.31,20.88,0,0-.77,2.32-.4,2.88s7.4,7.67,7.4,7.67l6-7.84s-4.4-5.39-5.81-6.37c-.59-.41-3.38-.3-3.38-.3s-10.21-17.33-12.24-18.93S109.86,212.76,109.31,216.16Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,224.35s6.51,8.71,12.56,7.24,12.28-7,12.28-7,2.84,1.78,4.17,1.75,8.34-1.23,8.34-1.23l-3.28-7.47s-6.09.4-7.7.36-3.58,2.5-3.58,2.5-9.63,2.44-11,2.38-6.11-5.32-6.11-5.32Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,204.22c5.59,2.63,16.72,15.77,16.72,15.77l-8.3,9.57L168.37,220s-1.19-7.62-.23-11A8.22,8.22,0,0,1,172,204.22Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.62 399.88 150.93 391.44 148.75 387.69 134.79 396.2 137.62 399.88",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.01 400.8 169.13 400.8 169.13 396.28 153.44 395.99 154.01 400.8",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,179.79a1.55,1.55,0,1,0,1.88-1.14A1.55,1.55,0,0,0,141.28,179.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.14,169s2.44,9.36-2.23,13.55S156.39,169,156.39,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,187.92a8.72,8.72,0,0,1-.36,1,9.66,9.66,0,0,1-5,5,8.87,8.87,0,0,1-6.41.33,8.68,8.68,0,0,1-3.85-2.64c-3.25-3.72-2.9-7.77-2.86-14.64a9.41,9.41,0,0,1,13.56-8.55C166.29,171.59,166.57,181.85,164.69,187.92Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.48,179.57c-.08.55.22,1,.6,1.05s.68-.41.72-1-.23-1-.59-1.05S156.52,179,156.48,179.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79,180c-.07.55.24,1,.6,1.05s.69-.41.73-1-.23-1-.6-1.05S162.83,179.45,162.79,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.77,180.12a19.82,19.82,0,0,0,2.36,5,3.29,3.29,0,0,1-2.72.33Z",
    style: {
      fill: "#892b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.31,177.43a.32.32,0,0,1-.34,0,2.62,2.62,0,0,0-2.34-.43.33.33,0,0,1-.42-.19.32.32,0,0,1,.19-.42h0a3.25,3.25,0,0,1,2.95.5.32.32,0,0,1,.09.45h0A.29.29,0,0,1,165.31,177.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.39,177a.31.31,0,0,1-.18-.07.33.33,0,0,1,.06-.46h0a3.25,3.25,0,0,1,2.95-.55.32.32,0,0,1,.19.42h0a.33.33,0,0,1-.42.19h0a2.65,2.65,0,0,0-2.33.48A.34.34,0,0,1,155.39,177Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.78,168.74l.32,3a2.25,2.25,0,0,0-1.19,2.82c.94,2.57-.58,6.5-2.56,8,0,0,0-1.1-1-.86s-.78,6,1,8.78c0,0-2.7-2.53-4.15-8.59-1.34-5.61-1.44-10.27-.26-12.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,182.41a6.55,6.55,0,0,0,3.53,3.54c2.13.87,3.45-1,3.09-3.11-.34-1.9-1.84-4.71-4.08-4.65A2.93,2.93,0,0,0,142.82,182.41Z",
    style: {
      fill: "#9f5b53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,187.26a20.68,20.68,0,0,0-1.39,2.63l-.51-.14c-2.29-.62-3.15-1.67-3.4-2.64a3.08,3.08,0,0,1,0-1.45,3.13,3.13,0,0,1,.29-.77A11.15,11.15,0,0,0,159.6,187C160.07,187.19,160.37,187.26,160.37,187.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,187l-.44.76c-2.15-.59-3.59-1.3-4.09-2.14a3.13,3.13,0,0,1,.29-.77A11.15,11.15,0,0,0,159.6,187Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,189.75c-2.29-.62-3.15-1.67-3.4-2.64a7.72,7.72,0,0,1,2.4,1.2A2.86,2.86,0,0,1,158.47,189.75Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,171.33a2.23,2.23,0,1,0,2.69-1.64A2.23,2.23,0,0,0,141.57,171.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.82,174.72a1.55,1.55,0,1,0,1.88-1.14A1.56,1.56,0,0,0,141.82,174.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.61,176.84a1.55,1.55,0,1,0,1.88-1.14A1.56,1.56,0,0,0,141.61,176.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,170.78s-.64-4,5.7-6.93,13.1.8,17.35-1.76,4.11,8.43-4.86,9.43A70.4,70.4,0,0,1,142.75,170.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.33,162.25a3.34,3.34,0,1,0,4-2.45A3.33,3.33,0,0,0,155.33,162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,163.4a3.33,3.33,0,1,0,4-2.45A3.33,3.33,0,0,0,146,163.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.74,166.07a2.23,2.23,0,1,0,2.7-1.64A2.23,2.23,0,0,0,164.74,166.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,161.46a2.23,2.23,0,1,0,2.7-1.64A2.23,2.23,0,0,0,152,161.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,166a2.23,2.23,0,1,0,2.7-1.64A2.23,2.23,0,0,0,143,166Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,162.65a3.37,3.37,0,1,0,4.08-2.47A3.38,3.38,0,0,0,161.64,162.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-492"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,222.11l13.66,13.53c2-.08,2.78-4.72,3.1-8.46l-1.94-3.72,1.94-3.77h5.94l1.36,4.14-.74,3.35-2.94,1.42s-2.06,16.86-4.66,16.86-19.49-14.74-19.49-14.74Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.31 231.98 213.81 238.11 219.87 228.54 209.96 222.11 206.31 231.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.5 235.41 211.66 229.56 213.81 238.11 210.5 235.41",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.35 251.12 211.35 260.65 185.45 262.45 184.31 252.4 211.35 251.12",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.42 410.14 231.7 411.15 229.35 403.35 227.21 396.19 233.81 393.89 235.72 402.49 237.42 410.14",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.75 402.67 229.38 403.51 227.22 396.27 233.81 393.93 235.75 402.67",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.59,410.2a.15.15,0,0,1-.08-.16c0-.09.17-2.11,1-2.77a.91.91,0,0,1,.71-.21.54.54,0,0,1,.53.44c.15.74-1.25,2.28-2,2.67h-.08Zm1.12-2.73a4,4,0,0,0-.83,2.19c.72-.54,1.61-1.71,1.52-2.16,0-.05,0-.17-.24-.17h-.08A.57.57,0,0,0,240.71,407.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.22 412.78 193.41 412.78 192.46 404.6 191.6 397.13 198.49 395.98 198.88 404.87 199.22 412.78",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.88 404.94 192.46 404.66 191.6 397.16 198.49 396 198.88 404.94",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.29,398.13l-9.4,1.66c-9.49-23.65-16.25-43.38-21-59.76-2.57-8.84-4.71-16.7-6.25-23.67l.29,25.74v58h-9.27c-23.23-110.65-6.77-135.86-6.77-135.86l27.8-4.63A127.47,127.47,0,0,1,214,275.2l1.26,9.22,10.86,56.12Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.29,398.13l-9.4,1.66c-9.49-23.65-16.25-43.38-21-59.76-2.57-8.84-4.71-16.7-6.25-23.67l.29,25.74v58h-9.27c-23.23-110.65-6.77-135.86-6.77-135.86l27.8-4.63A127.47,127.47,0,0,1,214,275.2l1.26,9.22,10.86,56.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.88,340c-2.57-8.84-4.57-16.7-6.11-23.67a218.72,218.72,0,0,1,1.8-24.68S205.64,323.51,205.88,340Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.69,264.34,181.63,267c1-6.29,1.46-16.95-.58-24.17-.31-1.08-.65-2.22-1-3.44q-.66-2.1-1.5-4.51c-.43-1.24-.9-2.56-1.42-4-.14-.41-.3-.83-.46-1.25-.52-1.41-1.08-2.91-1.7-4.49a90.64,90.64,0,0,1,11.33-2.44,98.53,98.53,0,0,1,12.27-1.15c5.31,0,11.42.49,11.42.49s.86.19,1.41,5.21C211.87,232,214.78,247.18,213.69,264.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.23,223.21a6.48,6.48,0,0,0-.83-.35c-.64-.5-1.4-1.7-1.36-4.61a23.69,23.69,0,0,1,.31-3.41l-8.1-1.51s2.76,5.45.46,9.5c-.79.35-1.27.85-1.18,1.51.61,4.68,9.53,5.6,9.53,5.6S203.11,225.9,198.23,223.21Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.35,214.84c-.95,2.57-3.06,4.35-6.76,5.06a13.27,13.27,0,0,0-1.34-6.57Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.48,187.72s-1-8.62,6.93-5.79,6.9,17.24,10.71,22,6.66,4.24,6.66,4.24-4.76,3.94-9.32,1.76S200.48,187.72,200.48,187.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,189.05l1.88-1.28a5,5,0,0,1,3.28,2.55,10,10,0,0,1,1.24,4.17l-2.54,1.09Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.88,188.86s-9.55-.67-10.87,7.07a11.76,11.76,0,0,0,4.81,11.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,192.88c-7.05,0-9.32,3.79-9.83,11.06-.63,9.08,1.39,15.54,10.21,13.59C204.32,214.88,203.68,192.87,192,192.88Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,203.54a14.8,14.8,0,0,1-2,2.93,1.93,1.93,0,0,0,1.86.79Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,203c0,.58.29,1.06.67,1.06s.71-.45.73-1-.29-1.06-.68-1.06S191,202.38,191,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.9,202l-1.25-.53S191.26,202.51,191.9,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,202.68c0,.58.29,1,.67,1.06s.71-.45.73-1-.29-1.06-.68-1.06S183.83,202.1,183.82,202.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.7,201.68l-1.25-.53S184.06,202.23,184.7,201.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.14,199.49a.32.32,0,0,1-.26-.12,3.34,3.34,0,0,0-2.75-.94.36.36,0,0,1-.39-.3.34.34,0,0,1,.3-.38,4,4,0,0,1,3.37,1.18.35.35,0,0,1,0,.49A.34.34,0,0,1,194.14,199.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,198.72a.35.35,0,0,1-.29-.15.34.34,0,0,1,.1-.48,3.63,3.63,0,0,1,3.11-.62.35.35,0,0,1,.21.44.35.35,0,0,1-.44.21,3,3,0,0,0-2.5.55A.45.45,0,0,1,183.15,198.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69,204.76s-3.3-5.79-2.81-10.26c0,0-14-5.7-14.65,8.49,0,0-1.39-12.59,10.74-12.89s12.09,17.44,5.84,22.74C198.81,212.84,201.74,208.38,199.69,204.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,188.38s-5.86-1.09-7.41.53,10.72,11.76,16.89,12.51c0,0,2.45,6.64,1,9.9,0,0,6.74-2.79,6.48-13.27S195.11,184.25,189.65,188.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,206.25a3.1,3.1,0,0,1,3.33-2.83c2.19.24,3.23,4.72-2.2,5.81C198.89,209.38,198.45,208.62,198.54,206.25Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.83,209.77a21,21,0,0,1,1.26,2.69l.51-.11c2.32-.51,3.23-1.51,3.53-2.47a3,3,0,0,0,.07-1.44,2.93,2.93,0,0,0-.24-.79,11.19,11.19,0,0,1-4.35,1.93C186.13,209.71,185.83,209.77,185.83,209.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.61,209.58l.4.78c2.18-.48,3.65-1.11,4.19-1.92a2.93,2.93,0,0,0-.24-.79A11.19,11.19,0,0,1,186.61,209.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.6,212.35c2.32-.51,3.23-1.51,3.53-2.47a7.81,7.81,0,0,0-2.46,1.08A2.9,2.9,0,0,0,187.6,212.35Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.63,410.16a.15.15,0,0,1-.12-.14.14.14,0,0,1,.08-.16c.25-.16,2.51-1.55,3.28-1.15a.5.5,0,0,1,.29.46,1,1,0,0,1-.35.89,2.06,2.06,0,0,1-1.34.36A8.78,8.78,0,0,1,239.63,410.16Zm.48-.23a3.38,3.38,0,0,0,2.5-.13.69.69,0,0,0,.22-.59c0-.14-.06-.2-.11-.2a.38.38,0,0,0-.21,0A6.76,6.76,0,0,0,240.11,409.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,410.16a.15.15,0,0,1-.12-.14.14.14,0,0,1,.08-.16c.25-.16,2.51-1.55,3.28-1.15a.5.5,0,0,1,.29.46,1,1,0,0,1-.35.89,2.06,2.06,0,0,1-1.34.36A8.78,8.78,0,0,1,200.63,410.16Zm.48-.23a3.38,3.38,0,0,0,2.5-.13.69.69,0,0,0,.22-.59c0-.14-.06-.2-.11-.2a.38.38,0,0,0-.21,0A6.76,6.76,0,0,0,201.11,409.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.59,410.2a.15.15,0,0,1-.08-.16c0-.09.17-2.11,1-2.77a.91.91,0,0,1,.71-.21.54.54,0,0,1,.53.44c.15.74-1.25,2.28-2,2.67h-.08Zm1.12-2.73a4,4,0,0,0-.83,2.19c.72-.54,1.61-1.71,1.52-2.16,0-.05,0-.17-.24-.17h-.08A.57.57,0,0,0,201.71,407.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.15,409.19h-8.51a.61.61,0,0,0-.6.48l-1.38,6.24a1,1,0,0,0,.8,1.22.83.83,0,0,0,.22,0c2.76-.05,4.76-.22,8.22-.22,2.13,0,8.56.23,11.5.23s3.32-2.91,2.12-3.18c-5.4-1.17-9.47-2.8-11.19-4.36A1.71,1.71,0,0,0,239.15,409.19Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.15,409.19h-8.51a.61.61,0,0,0-.6.48l-1.38,6.24a1,1,0,0,0,.8,1.22.83.83,0,0,0,.22,0c2.76-.05,4.76-.22,8.22-.22,2.13,0,8.56.23,11.5.23s3.32-2.91,2.12-3.18c-5.4-1.17-9.47-2.8-11.19-4.36A1.71,1.71,0,0,0,200.15,409.19Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,239.41q-.66-2.1-1.5-4.51c-.43-1.24-.9-2.56-1.42-4a4.74,4.74,0,0,1,1.13-1.65S180.31,235,180,239.41Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94,225.21c-3.63,1.79-14.47,19-11.38,24.79s17,10.88,17,10.88-5.8,3.19-5.6,4,5,4,5.6,4a39.7,39.7,0,0,0,4.68-4.2c.69-.78.09-4.06.09-4.06-3.92-3.19-14.69-10.87-15.35-12.59s8.42-13.57,8.42-13.57.26-4.92-.83-7.12S174.94,225.21,174.94,225.21Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,241.71l-8.07-6.06c3.14-4.35,5.62-10.58,8.73-10.44s3.63,4.47,3.58,9.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-4-and-5--inject-492"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.05,183.29s-7.37-4.09-13.38-1c-2.77,1.4-3.74,5-4.33,7.78-.81,3.9-.94,7.91-1.5,11.85a14.92,14.92,0,0,1-1.41,4.8c-1,2-3.11,4-2.69,6.45.36,2.16,2.57,3.46,4.5,4.05,5.11,1.57,10.9.7,16.18,1,4.25.27,8.36,1.71,12.62,1.81a6.4,6.4,0,0,0,3.51-.7c4.11-2.45,2.32-8.75,1-12.25-1.13-3-.3-6-.66-9.13a29.33,29.33,0,0,0-1.92-8C372.83,184.9,368.55,182.22,363.05,183.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66,236.2c1.37-.12,14.91-8.91,14.91-8.91l.48-3.67.51-4c-2-.07-14.15,9.63-15.89,10.48C324.14,231.84,324.54,236.46,327.66,236.2Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.92 229.62 342.57 227.28 343.08 223.35 338.92 229.62",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.45,221.15s-6.06,6.16-6.81,32.35l-27.13-2.19s-4.32-18.69-1-31.9A68.77,68.77,0,0,1,378.45,221.15Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.45,221.15s-6.06,6.16-6.81,32.35l-27.13-2.19s-4.32-18.69-1-31.9A68.77,68.77,0,0,1,378.45,221.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.73 402.21 326.15 403.17 328.38 395.77 330.41 388.98 324.15 386.79 322.33 394.95 320.73 402.21",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.3 395.12 328.35 395.92 330.39 389.05 324.14 386.83 322.3 395.12",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.95 404.71 362.47 404.71 363.37 396.95 364.19 389.86 357.65 388.78 357.28 397.21 356.95 404.71",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.28 397.28 363.37 397.01 364.19 389.9 357.65 388.79 357.28 397.28",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.79,390.81l8.92,1.58c9-22.43,15.41-41.15,19.93-56.69,2.44-8.38,4.47-15.84,5.93-22.46l-.27,24.42v55h8.79c22-105,6.21-135.71,6.21-135.71l-26.8-1.7c-1,3.93-1.12,14.5-1.56,18.94L341.75,283l-10.31,53.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.64,335.7c2.44-8.38,4.34-15.84,5.8-22.46a206.66,206.66,0,0,0-1.71-23.41S350.87,320,350.64,335.7Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.64 253.5 344.51 251.31 344.51 255.92 372.04 258.35 371.64 253.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352,253.35v2.13a1.67,1.67,0,0,0,1.52,1.67l3.36.29H357a1.69,1.69,0,0,0,1.13-.44,1.65,1.65,0,0,0,.54-1.23v-2.14a1.66,1.66,0,0,0-1.52-1.67l-3.36-.29a1.68,1.68,0,0,0-1.81,1.67Zm.86,2.13v-.7h0l.94.07a.57.57,0,1,0,.09-1.13l-.94-.08-.13,0v-.32a.79.79,0,0,1,.26-.6.78.78,0,0,1,.54-.21h.08l3.35.29a.8.8,0,0,1,.74.81v2.14a.81.81,0,0,1-.26.6.78.78,0,0,1-.62.2l-3.35-.29A.81.81,0,0,1,352.87,255.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.43,218.43a2,2,0,0,1,1.14,1,14.78,14.78,0,0,1-9.11,2.86c-.92,0-2.83-2.6-1.4-3.4a6.3,6.3,0,0,1,.82-.36c.61-.49,1.36-1.68,1.31-4.54a23.32,23.32,0,0,0-.33-3.36l8-1.54S362.14,214.46,364.43,218.43Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.86,210.61a23.32,23.32,0,0,1,.33,3.36c5.39,0,7.64-4.9,7.64-4.9Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11,399.24l-10.45-2v7.43s-5.34,8.87-7.65,9.47a2.54,2.54,0,0,0-1.83,3h11.54l2.8-3.35.61,3.35h2.22s2.34-6.75,0-11.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,398.31l-10.45.81.92,5.59s-5.35,8.87-7.66,9.47a2.52,2.52,0,0,0-1.82,3h11.54l2.8-3.35.6,3.35h2.22s2.34-6.75,0-11.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6,188.07c-7,0-9.19,3.72-9.7,10.87-.64,8.95,1.34,15.3,10,13.4C371.72,209.75,371.13,188.08,359.6,188.07Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.39,198.56a14.71,14.71,0,0,1-2,2.88,1.9,1.9,0,0,0,1.83.78Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64,198c0,.57.29,1,.67,1s.7-.44.71-1-.28-1-.66-1.05S358.66,197.42,358.64,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,197l-1.23-.52S358.88,197.55,359.51,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.55,197.7c0,.57.29,1,.67,1.05s.7-.44.71-1-.28-1-.66-1.05S351.57,197.13,351.55,197.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.42,196.72l-1.22-.52S351.79,197.26,352.42,196.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.73,194.59a.34.34,0,0,1-.27-.13,3.3,3.3,0,0,0-2.7-.92.34.34,0,0,1-.38-.3.33.33,0,0,1,.29-.38A3.93,3.93,0,0,1,362,194a.34.34,0,0,1-.05.48A.29.29,0,0,1,361.73,194.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.9,193.81a.34.34,0,0,1-.19-.63,3.6,3.6,0,0,1,3.08-.6.35.35,0,0,1,.2.44.34.34,0,0,1-.44.2h0a2.93,2.93,0,0,0-2.46.54A.45.45,0,0,1,350.9,193.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.18,199.78s-3.24-5.7-2.75-10.11c0,0-13.76-5.63-14.45,8.34,0,0-1.33-12.41,10.61-12.68s11.87,17.2,5.7,22.4C366.29,207.73,369.19,203.35,367.18,199.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.05,201.25a3,3,0,0,1,3.28-2.78c2.15.23,3.17,4.65-2.18,5.71C366.38,204.33,366,203.58,366.05,201.25Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,204a18.62,18.62,0,0,1,.83,2.61l.48,0c2.18-.19,3.13-1,3.53-1.83a3.07,3.07,0,0,0,.1-2.07,10.23,10.23,0,0,1-4.2,1.25C354.27,204,354,204,354,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.72,203.94l.27.76c2.05-.18,3.47-.58,4.06-1.26a2.85,2.85,0,0,0-.13-.75A10.23,10.23,0,0,1,354.72,203.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,206.59c2.18-.19,3.13-1,3.53-1.83a6.9,6.9,0,0,0-2.38.68A2.7,2.7,0,0,0,355.29,206.59Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,241.52c1.57,1.23,4.53.11,6.7-1.27,1-5.6,1.39-9.83,2.34-12.75C373.4,229,363.05,239.26,365.92,241.52Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.54,236.6h0a.25.25,0,0,1-.2-.17c-.14-.52-3.32-12.83-.75-18.47a.23.23,0,0,1,.31-.12.24.24,0,0,1,.11.31c-2.19,4.79,0,14.94.63,17.55,4.14-8.34,12.93-17.07,13-17.16a.22.22,0,0,1,.32,0,.24.24,0,0,1,0,.33c-.09.09-9.23,9.17-13.21,17.6A.23.23,0,0,1,354.54,236.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.42,240.68a2.33,2.33,0,1,1,2.32-2.32A2.32,2.32,0,0,1,354.42,240.68Zm0-3.72a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,354.42,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.06,229.7l-2.56-5s.37-4.55,0-4.91-5.46-2.54-7.29-2.54-2,6.69-1.27,7.45S349.3,227,349.3,227l4.64,3.47Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.45,221.15c4.5,4.47-9,22.15-13.62,22.15S349.3,227,349.3,227l3.2-2.28s10.89,11.4,11.83,11.44,8.18-11,9.5-12.33A13.12,13.12,0,0,1,378.45,221.15Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.86,222.07l-5.24-3a13.51,13.51,0,0,0-2.38-2.93c-1.08-.81-5.52-2-5.52-2-1.64-.36-2.51.15-3,1.11l-2.49,5.66c-.41,1-.38,1.46,0,1.53,0,0,8.64,2.14,10.78.27l5.32,3.09Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91,204.92a3.2,3.2,0,0,1-.44,2.26c-1.32,2.46-6.69,12.92-9.28,16.27-4.2,5.44-7.6,8.35-10.21,8.53-4.32.31-17.08-5.35-17.08-5.35l5.05-7.56s7.56,3.48,10.77,2.75,9.35-17.51,11.54-21.72C286.26,200.1,295,201,295.91,204.92Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,228.14a8.86,8.86,0,0,1-2.84,2.45c1.84-4,4.63-19.38,4.63-19.38Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,409.56h8.66a.62.62,0,0,1,.6.49l1.41,6.34a1.06,1.06,0,0,1-.81,1.25.65.65,0,0,1-.24,0c-2.8,0-4.84-.21-8.35-.21-2.17,0-8.7.22-11.69.22s-3.38-2.95-2.16-3.22c5.49-1.2,9.62-2.86,11.38-4.44A1.77,1.77,0,0,1,317,409.56Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,409.56h8.66a.62.62,0,0,1,.6.49l1.41,6.34a1.06,1.06,0,0,1-.81,1.25.65.65,0,0,1-.24,0c-2.8,0-4.84-.21-8.35-.21-2.17,0-8.7.22-11.69.22s-3.38-2.95-2.16-3.22c5.49-1.2,9.62-2.86,11.38-4.44A1.77,1.77,0,0,1,317,409.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,409.33h8.66a.63.63,0,0,1,.6.49l1.41,6.35a1,1,0,0,1-.81,1.24l-.23,0c-2.8-.05-4.84-.22-8.36-.22-2.17,0-8.7.23-11.69.23s-3.38-3-2.16-3.23c5.49-1.2,9.63-2.86,11.39-4.43A1.74,1.74,0,0,1,280.26,409.33Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,409.33h8.66a.63.63,0,0,1,.6.49l1.41,6.35a1,1,0,0,1-.81,1.24l-.23,0c-2.8-.05-4.84-.22-8.36-.22-2.17,0-8.7.23-11.69.23s-3.38-3-2.16-3.23c5.49-1.2,9.63-2.86,11.39-4.43A1.74,1.74,0,0,1,280.26,409.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.56,249.11H283.74c-3.59,19.63-14.85,99.36-6.77,161.27h12.8s-1.19-94,10.12-124.4c1.3,16.26,14.51,124.34,14.51,124.34h13s-1.95-40.66-3.9-79.06C322.31,307.07,321.61,254.07,321.56,249.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.56,249.11H283.74c-3.59,19.63-14.85,99.36-6.77,161.27h12.8s-1.19-94,10.12-124.4c1.3,16.26,14.51,124.34,14.51,124.34h13s-1.95-40.66-3.9-79.06C322.31,307.07,321.61,254.07,321.56,249.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,286a102.33,102.33,0,0,0-4.22,16.36c-1.06-14.47,3.17-29.82,3.17-29.82Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "288.64 253.69 282.94 253.63 283.43 249.56 288.64 249.56 288.64 253.69"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "309.26 249.56 321.49 249.56 321.49 254.09 309.26 253.95 309.26 249.56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "307.9 253.93 290 253.71 290 249.56 307.9 249.56 307.9 253.93"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.37,254.2h-4.23a1.09,1.09,0,0,1-1.09-1.1v-2.71a1.09,1.09,0,0,1,1.09-1.09h4.23a1.09,1.09,0,0,1,1.09,1.09v2.71A1.09,1.09,0,0,1,299.37,254.2Zm-4.23-3.9a.09.09,0,0,0-.09.09v2.71a.1.1,0,0,0,.09.1h4.23a.1.1,0,0,0,.09-.1v-2.71a.09.09,0,0,0-.09-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,252.13h-2.19a.5.5,0,1,1,0-1h2.19a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.46,203.12c-.44,1.57-.93,3.62-1.41,6.11-.56,2.83-1.12,6.23-1.6,10.07a221.78,221.78,0,0,0-1.35,30.26l-40.88-.35s-1.69-26.52,4-49.11l38.5-.48A2.75,2.75,0,0,1,327.46,203.12Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.05,209.23c-.56,2.83-1.56,10.29-2.05,14.13-3.77-1.83-4.05-11.73-4.05-11.73C321.61,211.39,325.25,208.49,326.05,209.23Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.75,203.66s8.09.07,11-3.29c-1.83-1.55-2.62-4.63-2.86-7.93a41.91,41.91,0,0,1,.13-7c.06-.76.15-1.46.24-2.1l-8.9,8.52c0,.15.09.3.14.46.13.45.25.92.34,1.37a8.83,8.83,0,0,1,.13,3.38,7.28,7.28,0,0,1-.47,2.24c-.29.47-.88.85-2.19,1.24C298.42,202.19,301.75,203.66,301.75,203.66Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.46,199.27c2.74-1,6.12-5.19,8.2-8.92a20.8,20.8,0,0,1,.32-4.95l-8.52,6.88c.13.45.25.92.34,1.37a8.83,8.83,0,0,1,.13,3.38A7.28,7.28,0,0,1,301.46,199.27Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,168.92s-2.57,9.46,2.11,13.74S301.4,169,301.4,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,192a8.78,8.78,0,0,1-10.41,2.24,9.77,9.77,0,0,1-5-5.16,8.18,8.18,0,0,1-.36-1c-1.84-6.17-1.46-16.55,5.2-19.69a9.52,9.52,0,0,1,12.7,4.47,9.33,9.33,0,0,1,.94,4.32C311.63,184.18,311.94,188.27,308.61,192Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21,179.74c.07.56-.24,1-.62,1.06s-.69-.43-.72-1,.24-1,.61-1.06S301.17,179.17,301.21,179.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.81,180.09c.07.56-.25,1-.61,1.06s-.7-.43-.73-1,.25-1,.61-1.06S294.78,179.55,294.81,180.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.86,180.26a20.44,20.44,0,0,1-2.44,5,3.29,3.29,0,0,0,2.75.36Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.33,177.59a.32.32,0,0,0,.34-.05A2.72,2.72,0,0,1,295,177a.31.31,0,0,0,.41-.21.32.32,0,0,0-.21-.41h0a3.31,3.31,0,0,0-2.95.69.33.33,0,0,0-.06.47h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.33,177.12a.29.29,0,0,0,.18-.07.32.32,0,0,0-.05-.46h0a3.28,3.28,0,0,0-3-.62.34.34,0,0,0-.21.42h0a.36.36,0,0,0,.43.21h0a2.64,2.64,0,0,1,2.34.53A.37.37,0,0,0,302.33,177.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.08,168.82l-.6,1.33c2.3.73,1.87,3.4,1.41,4.62-1,2.59.53,6.58,2.52,8.16,0,0,0-1.12,1-.86s.72,6.08-1.1,8.87c0,0,2.77-2.53,4.3-8.65,1.41-5.67,1.56-10.38.38-12.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,182.75a6.63,6.63,0,0,1-3.6,3.55c-2.16.86-3.49-1-3.1-3.18.36-1.93,1.91-4.75,4.18-4.66A3,3,0,0,1,315,182.75Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,187.55a20.55,20.55,0,0,1,1.31,2.72l.52-.11c2.35-.53,3.26-1.56,3.56-2.53a3.24,3.24,0,0,0,.06-1.47,3.07,3.07,0,0,0-.26-.8,11.4,11.4,0,0,1-4.39,2C297.68,187.49,297.36,187.55,297.36,187.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.16,187.36l.41.79c2.21-.51,3.7-1.16,4.24-2a3.07,3.07,0,0,0-.26-.8A11.4,11.4,0,0,1,298.16,187.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.19,190.16c2.35-.53,3.26-1.56,3.56-2.53a7.73,7.73,0,0,0-2.49,1.11A2.84,2.84,0,0,0,299.19,190.16Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,168.92c.55-3.16,2-5.78,3.67-8.86l.49,3.59a10.3,10.3,0,0,1,3.19-3.38l.64,3.86c.75-1.66,2.43-2.62,4.62-3.19l-.32,3.33a7.22,7.22,0,0,1,4.17-3l-.17,3.16a2.9,2.9,0,0,1,2.34-1.39l2.81,6.65-6.83,2.2-13.28.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83,249l-.35,6.15a13.4,13.4,0,0,1,1.16,3.65c.08,1.37-2.86,10.42-2.86,10.42l-7.28-3.74s1.64-9.43,4.43-10.2l.35-6.24Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.44,201.54c5.3,11.17,11.15,21.94,9.73,28.77l-3.83,23.89-7.37-.3L328.45,232c2.3-4-4.26-12.81-8.5-20.35Z",
    style: {
      fill: "#4B706C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.87 230.11 343.68 239.07 340.65 241.84 326.57 235.97 327.87 230.11",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.05,237.54l3.6,4.3s.66,4.51,1.09,4.78,5.9,1.26,7.67.85.47-7-.41-7.54-5.73-1-5.73-1l-5.3-2.35Z",
    style: {
      fill: "#ebb376"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersImage);
export default __webpack_public_path__ + "static/media/users-image.1ba4e998b9a00f162bc62e2c9d7fa611.svg";
export { ForwardRef as ReactComponent };